export const OPENAI_SUPPORTED_MODELS = [
  'o4-mini',
  'gpt-4.1',
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-5',
] as const;

export const ANTHROPIC_SUPPORTED_MODELS = [
  // Keep currently supported defaults first to avoid breaking defaults
  'claude-sonnet-5-5',
  'claude-sonnet-4-6',
  'claude-3-7-sonnet-20250219',
  'claude-3-5-sonnet-20241022',
  'claude-3-5-haiku-20241022',
  // Additional models requested
  'claude-opus-4-1-20250805',
  'claude-opus-4-20250514',
  'claude-sonnet-4-20250514',
  'claude-3-5-sonnet-20240620',
  'claude-3-haiku-20240307',
  'claude-3-opus-20240229',
] as const;

export type OpenAIModel = (typeof OPENAI_SUPPORTED_MODELS)[number];
export type AnthropicModel = (typeof ANTHROPIC_SUPPORTED_MODELS)[number];
export type SupportedProvider = 'openai' | 'anthropic';

export const LLM_MODEL_OPTIONS: Record<SupportedProvider, string[]> = {
  openai: [...OPENAI_SUPPORTED_MODELS],
  anthropic: [...ANTHROPIC_SUPPORTED_MODELS],
};
